import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ValidationOverviewData } from '../../constants/validationOverviewData';
import Table from '../../ui/Table';
import Input from '../../ui/Input';
import SortIcon from '../../assets/icons/SortIcon';
import Tag from '../../ui/Tag';
import search from '../../assets/search.png';
import Heading from '../../ui/Heading';
import { getBountiesInProject, getBountiesInProjectCount } from '../../apis/projects/projects';
import Pagination from '../../ui/Pagination';
import Menus from '../../ui/Menus';
import AvatarImage from '../../ui/AvatarImage';
import Modal from '../../ui/Modal';
import DeleteBountyModal from '../bounties/DeleteBountyModal';
import DeleteIcon from '../../assets/icons/DeleteIcon';
import RequestTreasuryMenuIcon from '../../assets/icons/RequestTreasuryMenuIcon';
import PublishMenuIcon from '../../assets/icons/PublishMenuIcon';
import DuplicateBountyModal from '../bounties/DuplicateBountyModal';
import DuplicateMenuIcon from '../../assets/icons/DuplicateMenuIcon';
import EditMenuIcon from '../../assets/icons/EditMenuIcon';
import { BOUNTY_STATUS_TAG_COLOR } from '../../constants/datas';
import { publishOrUnpublishBounty } from '../../apis/bounties/bounties';
import RequestTreasuryApprovalModal from '../bounties/RequestTreasuryApprovalModal';
import PopOver from '../../ui/PopOver';
import StartBountyModal from '../bounties/StartBountyModal';
import { toast } from 'sonner';
import { AuthContext } from '../../contexts/AuthContext';
import TruncatedTextWithTooltip from '../../ui/TruncatedTextWithTooltip';
import ToastIcon from '../../assets/icons/ToastIcon';
import RePublishBountyModal from '../bounties/RePublishBountyModal';
import ExtendBountyDateModal from '../bounties/ExtendBountyDateModal';
import ForcefullyExpireBountyModal from '../bounties/ForcefullyExpireBounty';
import ExpireBountyIcon from '../../assets/icons/ExpireBountyIcon';
import ExtendBountyDateIcon from '../../assets/icons/ExtendBountyDateIcon';
import RePublishBountyIcon from '../../assets/icons/RePublishBountyIcon';
import NoDataAvailable from '../../ui/NoDataAvailable';

function BountiesInProject({ projectTitle }) {
    const [bountiesInProject, setBountiesInProject] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false); // Modal visibility state
    const [modalAction, setModalAction] = useState(''); // Track action type: 'duplicate' or 'delete'
    const [selectedBounty, setSelectedBounty] = useState(null); // Track selected bounty for modal
    const { state } = useContext(AuthContext);
    const { user } = state;
    const userProfile = user[0];
    let filteredData = bountiesInProject;
    const [searchString, setSearchString] = useState('');
    const { projectId, id } = useParams();
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [entriesPerPage, setEntriesPerPage] = useState(10);

    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    const countData = await getBountiesInProjectCount(projectId);
                    setTotalEntries(countData?.entryCount || 0);
                    const data = await getBountiesInProject(projectId, currentPage, entriesPerPage);

                    setBountiesInProject(data);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [projectId, currentPage, entriesPerPage]
    );

    const entriesHandler = (val) => {
        setEntriesPerPage(val);
        setCurrentPage(1);
    };
    const handleTogglePublish = async (oppStatus, id) => {
        try {
            const afterToggling = bountiesInProject.map((bounty) => {
                if (bounty._id === id) return { ...bounty, status: oppStatus };
                return bounty;
            });
            setBountiesInProject(afterToggling);
            const res = await publishOrUnpublishBounty(id);
        } catch (error) { }
    };

    const handleOpenModal = (action, bounty) => {
        setModalAction(action); // Set the action type ('duplicate' or 'delete')
        setSelectedBounty(bounty); // Set the selected bounty
        setModalOpen(true); // Open the modal
    };

    const handleCloseModal = () => {
        setModalOpen(false); // Close the modal
        setModalAction(''); // Clear action type
        setSelectedBounty(null); // Clear selected bounty
    };

    const handleConfirmAction = (newBounty, newStatus) => {
        if (modalAction === 'duplicate') {
            setBountiesInProject((prev) => {
                const index = prev.findIndex((bounty) => bounty._id === selectedBounty._id);
                const updatedBounties = [...prev];
                updatedBounties.splice(index + 1, 0, {
                    ...newBounty,
                    creatorProfileImage: userProfile?.profileImage,
                    creatorUsername: userProfile?.userName,
                    projectTitle: selectedBounty?.projectTitle,
                }); // Insert the duplicate right after the original
                return updatedBounties;
            });
            // Perform duplication logic here
        } else if (modalAction === 'delete') {
            setBountiesInProject((prev) => prev.filter((bounty) => bounty._id !== selectedBounty._id));
        } else if (modalAction === 'request') {
            setBountiesInProject((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: 'Creation Requested' };
                    }
                    return bounty;
                })
            );
        } else if (modalAction === 'start') {
            setBountiesInProject((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: 'Live and Published' };
                    }
                    return bounty;
                })
            );
        }
        else if (modalAction === 'expire') {
            setBountiesInProject((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: newStatus };
                    }
                    return bounty;
                })
            );
        }
        else if (modalAction === 'extend') {
            setBountiesInProject((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty };
                    }
                    return bounty;
                })
            );
        }
        else if (modalAction === 'republish') {
            setBountiesInProject((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: "Live and Published" };
                    }
                    return bounty;
                })
            );
        }
        handleCloseModal();
    };
    const updateRenderData = (type, id) => {
        if (type === 'delete') {
            setBountiesInProject((initial) => initial.filter((bounty) => bounty._id !== id));
        }
        // if (type === 'duplicate') setBounties(initial);
    };
    if (searchString)
        filteredData = filteredData.filter(({ _id, status, title, projectTitle }) =>
            title
                ?.toLowerCase()
                ?.includes(searchString?.toLowerCase() || projectTitle?.toLowerCase()?.includes(searchString?.toLowerCase()))
        );

    // /organizations/6609a9cae9b44a9794cb323d/view-bounties/66bade3a110b13247911870e

    console.log(filteredData, "check bounty in pro")

    return (
        <>
            <Menus>
                <Table className="gap-8 " cols="grid-cols-tableBountiesProject">
                    <Table.Description
                        description="Bounties in the Project"
                        primaryBtn="+ Add Bounty"
                        clickOnPrimary={() =>
                            navigate(`/${id}/createBounty?projectId=${projectId}&projectTitle=${projectTitle}`)
                        }
                    />
                    <div className="flex items-center w-[441px] gap-3 py-2 px-3 mb-4 border border-borderUnderline rounded-lg ">
                        <img className="w-6 h-6  object-cover" src={search} alt="" />
                        <Input
                            value={searchString}
                            onChange={(e) => setSearchString(e.target.value)}
                            placeholder="Search Bounty Title or Project Title"
                            className=" !w-full !border-0 !px-0 !py-0 outline-none "
                            containerClass="flex-1"
                            type="text"
                        />
                    </div>
                    <Table.Header>
                        <p className="text-sm justify-self-start  font-semibold text-secondaryText ">Bounty ID</p>
                        <p className="text-sm  font-semibold text-secondaryText ">Bounty Title</p>
                        {/* <p className="text-sm  font-semibold text-secondaryText ">Project Title</p> */}
                        <p className="text-sm  font-semibold text-secondaryText ">Status</p>
                        <p className="text-sm  font-semibold text-secondaryText ">Created By</p>
                    </Table.Header>
                    {filteredData?.length > 0 ? filteredData.map((bounty) => (
                        <Table.Row key={bounty._id} rowClassName="relative">
                            <TruncatedTextWithTooltip
                                onClick={() => navigate(`/organizations/${id}/view-bounties/${bounty._id}`)}
                                containerClassName={'self-center'}
                                textClassName="text-textBrandBlue cursor-pointer truncate w-full uppercase font-medium"
                                text={bounty._id}
                            />
                            <p className="self-center">{bounty.title}</p>
                            {/* <p>{bounty.projectTitle}</p> */}

                            <PopOver
                                rounded="rounded-lg "
                                className="px-2 py-1 leading-3 self-center   "
                                textClassName="text-xs font-semibold"
                                bg={BOUNTY_STATUS_TAG_COLOR[bounty.status]?.bg}
                                textColor={BOUNTY_STATUS_TAG_COLOR[bounty.status]?.text}
                                borderColor={BOUNTY_STATUS_TAG_COLOR[bounty.status]?.border}
                                text={bounty.status}
                                active={
                                    bounty.status === 'Live and Published' || bounty.status === 'Live and Unpublished'
                                        ? 'Live'
                                        : bounty.status
                                }
                            />
                            <div className="flex items-center  gap-3 ">
                                <AvatarImage w="w-8" h="h-8" url={bounty.creatorProfileImage} />
                                <p className="text-textPrimary font-medium ">{bounty.creatorUsername}</p>
                            </div>

                            <Menus.Toggle id={bounty._id} />
                            {/* <Menus.List id={bounty._id}>
                            <Menus.Button icon={<EditMenuIcon />}>Edit</Menus.Button>
                            <Modal>
                                <Modal.Button
                                    className="flex gap-2 cursor-pointer items-center"
                                    opens={'duplicatebounty'}
                                >
                                    <Menus.Button icon={<DuplicateMenuIcon />}>Duplicate</Menus.Button>
                                </Modal.Button>
                                <Modal.Window name={'duplicatebounty'}>
                                    <DuplicateBountyModal bountyName={bounty.title} bountyId={bounty._id} />
                                </Modal.Window>
                            </Modal>

                            <Menus.Button icon={<PublishMenuIcon />}>Publish</Menus.Button>
                            <Menus.Button icon={<RequestTreasuryMenuIcon />}>Request Treaury Approval</Menus.Button>

                            <Modal>
                                <Modal.Button className="flex gap-2 cursor-pointer items-center" opens={'deletebounty'}>
                                    <Menus.Button icon={<DeleteIcon />}>Delete</Menus.Button>
                                </Modal.Button>
                                <Modal.Window name={'deletebounty'}>
                                    <DeleteBountyModal
                                        onDelete={updateRenderData}
                                        bountyName={bounty.title}
                                        bountyId={bounty._id}
                                    />
                                </Modal.Window>
                            </Modal>
                        </Menus.List> */}
                            <Menus.List id={bounty._id}>
                                {bounty?.receivedSubmissions && (
                                    <p className="w-72 text-sm py-3 px-4 flex items-center gap-2 shrink-0">
                                        <span className="flex-shrink-0">
                                            <ToastIcon className="flex-shrink-0" />
                                        </span>
                                        You can't edit this bounty since it has started to receive submissions
                                    </p>
                                )}
                                <Menus.Button
                                    shouldCloseMenu={true}
                                    onClick={(fn) => {
                                        handleOpenModal('duplicate', bounty);
                                        fn();
                                    }}
                                    icon={<DuplicateMenuIcon />}
                                >
                                    Duplicate
                                </Menus.Button>
                                {/* Delete Action */}
                                {/* {bounty.status === 'Draft' && (
                                    <Menus.Button
                                        onClick={(fn) => {
                                            handleOpenModal('delete', bounty);
                                            fn();
                                        }}
                                        icon={<DeleteIcon />}
                                    >
                                        Delete
                                    </Menus.Button>
                                )} */}
                                {
                                    bounty?.status === "Unvalidated" && (
                                        <>

                                            <Menus.Button
                                                width="w-full"
                                                onClick={(fn) => {
                                                    handleOpenModal('republish', bounty);
                                                    fn();
                                                }}
                                                icon={<RePublishBountyIcon />}
                                            >
                                                Re-publish <br /> Bounty
                                            </Menus.Button>
                                        </>
                                    )
                                }
                                {bounty.status === 'Draft' && (
                                    <>
                                        <Menus.Button
                                            disabled={bounty?.receivedSubmissions}
                                            menuBtnClassName={`${bounty?.receivedSubmissions ? 'cursor-not-allowed ' : ''
                                                }`}
                                            onClick={(fn) => {
                                                navigate(`/${id}/createBounty?bountyId=${bounty._id}`);
                                                fn();
                                            }}
                                            icon={<EditMenuIcon />}
                                        >
                                            Edit
                                        </Menus.Button>
                                        <Menus.Button
                                            onClick={(fn) => {
                                                handleOpenModal('delete', bounty);
                                                fn();
                                            }}
                                            icon={<DeleteIcon />}
                                        >
                                            Delete
                                        </Menus.Button>

                                        <Menus.Button
                                            onClick={(fn) => {
                                                handleOpenModal('start', bounty);
                                                fn();
                                            }}
                                            icon={<PublishMenuIcon />}
                                        >
                                            Publish
                                        </Menus.Button>
                                    </>
                                )}
                                {/* {bounty.status === 'Draft' && (
                                    <Menus.Button
                                        onClick={(fn) => {
                                            handleOpenModal('request', bounty);
                                            fn();
                                        }}
                                        icon={<RequestTreasuryMenuIcon />}
                                    >
                                        Request Treasury Approval
                                    </Menus.Button>
                                )} */}
                                {bounty.status === 'Live and Published' && (
                                    <>
                                        <Menus.Button
                                            disabled={bounty?.receivedSubmissions}
                                            menuBtnClassName={`${bounty?.receivedSubmissions ? 'cursor-not-allowed ' : ''
                                                }`}
                                            onClick={(fn) => {
                                                toast.error('Please unpublish the bounty first');
                                                fn();
                                            }}
                                            icon={<EditMenuIcon />}
                                        >
                                            Edit
                                        </Menus.Button>
                                        <Menus.Button
                                            onClick={() => handleTogglePublish('Live and Unpublished', bounty._id)}
                                            icon={<PublishMenuIcon />}
                                        >
                                            Unpublish
                                        </Menus.Button>
                                        <Menus.Button
                                            width="w-full"
                                            onClick={(fn) => {
                                                handleOpenModal('expire', bounty);
                                                fn();
                                            }}
                                            icon={<ExpireBountyIcon />}
                                        >
                                            Forcefully Expire <br /> Bounty
                                        </Menus.Button>
                                        <Menus.Button
                                            width="w-full"
                                            onClick={(fn) => {
                                                handleOpenModal('extend', bounty);
                                                fn();
                                            }}
                                            icon={<ExtendBountyDateIcon />}
                                        >
                                            Extend Bounty <br /> Date
                                        </Menus.Button>
                                    </>
                                )}
                                {bounty.status === 'Live and Unpublished' && (
                                    <>
                                        <Menus.Button
                                            disabled={bounty?.receivedSubmissions}
                                            menuBtnClassName={`${bounty?.receivedSubmissions ? 'cursor-not-allowed ' : ''
                                                }`}
                                            onClick={(fn) => {
                                                navigate(`/${id}/createBounty?bountyId=${bounty._id}`);
                                                fn();
                                            }}
                                            icon={<EditMenuIcon />}
                                        >
                                            Edit
                                        </Menus.Button>
                                        <Menus.Button
                                            onClick={() => handleTogglePublish('Live and Published', bounty._id)}
                                            icon={<PublishMenuIcon />}
                                        >
                                            Publish
                                        </Menus.Button>
                                        <Menus.Button
                                            width="w-full"
                                            onClick={(fn) => {
                                                handleOpenModal('expire', bounty);
                                                fn();
                                            }}
                                            icon={<ExpireBountyIcon />}
                                        >
                                            Forcefully Expire <br /> Bounty
                                        </Menus.Button>
                                        <Menus.Button
                                            width="w-full"
                                            onClick={(fn) => {
                                                handleOpenModal('extend', bounty);
                                                fn();
                                            }}
                                            icon={<ExtendBountyDateIcon />}
                                        >
                                            Extend Bounty <br /> Date
                                        </Menus.Button>
                                    </>
                                )}
                                {/* {bounty.status === 'Live and Published' && (
                                    <Menus.Button
                                        onClick={() => handleTogglePublish('Live and Unpublished', bounty._id)}
                                        icon={<PublishMenuIcon />}
                                    >
                                        Unpublish
                                    </Menus.Button>
                                )}
                                {bounty.status === 'Live and Unpublished' && (
                                    <Menus.Button
                                        onClick={() => handleTogglePublish('Live and Published', bounty._id)}
                                        icon={<PublishMenuIcon />}
                                    >
                                        Publish
                                    </Menus.Button>
                                )} */}
                            </Menus.List>
                        </Table.Row>
                    )) : <NoDataAvailable />}

                    {totalEntries > 10 && (
                        <div className="w-[100%] mx-auto">
                            <Pagination
                                className="pt-6 pb-[.65rem]"
                                hoverColor="hover:text-textPrimary"
                                currentColor="bg-neutral50D"
                                textActive="text-textPrimary"
                                currentPage={currentPage}
                                totalPages={Math.ceil(totalEntries / entriesPerPage)}
                                entriesPerPage={entriesPerPage}
                                totalEntries={totalEntries}
                                entriesHandler={entriesHandler}
                                onPageChange={setCurrentPage}
                                border="border-borderUnderline"
                                hoverBorder="hover:border-borderUnderline"
                            />
                        </div>
                    )}
                </Table>
            </Menus>
            {isModalOpen && (
                <div>
                    {modalAction === 'duplicate' && (
                        <DuplicateBountyModal
                            handleConfirmAction={handleConfirmAction}
                            bountyName={selectedBounty.title}
                            bountyId={selectedBounty._id}
                            close={handleCloseModal}
                        />
                    )}
                    {modalAction === 'start' && (
                        <StartBountyModal
                            handleConfirmAction={handleConfirmAction}
                            bountyName={selectedBounty.title}
                            bountyId={selectedBounty._id}
                            close={handleCloseModal}
                        />
                    )}
                    {modalAction === 'delete' && (
                        <DeleteBountyModal
                            onDelete={handleConfirmAction}
                            bountyName={selectedBounty.title}
                            bountyId={selectedBounty._id}
                            close={handleCloseModal}
                        />
                    )}
                    {modalAction === 'request' && (
                        <RequestTreasuryApprovalModal
                            handleConfirmAction={handleConfirmAction}
                            bountyName={selectedBounty.title}
                            bountyId={selectedBounty._id}
                            updatedTime={selectedBounty.updatedAt}
                            close={handleCloseModal}
                        />
                    )}
                    {modalAction === 'expire' && (
                        <ForcefullyExpireBountyModal
                            onForcefullyExpire={handleConfirmAction}
                            bountyName={selectedBounty.title}
                            bountyId={selectedBounty._id}
                            close={handleCloseModal}
                        />
                    )}
                    {modalAction === 'extend' && (
                        <ExtendBountyDateModal
                            onExtend={handleConfirmAction}
                            bountyName={selectedBounty.title}
                            isValidationDateRequired={selectedBounty?.validationType === "ALL_TOGETHER"}
                            bountyId={selectedBounty._id}
                            close={handleCloseModal}
                        />
                    )}
                    {modalAction === 'republish' && (
                        <RePublishBountyModal
                            onRepublish={handleConfirmAction}
                            bountyName={selectedBounty.title}
                            isValidationDateRequired={selectedBounty?.validationType === "ALL_TOGETHER"}
                            bountyId={selectedBounty._id}
                            close={handleCloseModal}
                        />
                    )}
                </div>
            )}
        </>
    );
}

export default BountiesInProject;
